/* BBT Theme 125: site-wide in-page back navigation. */
(function () {
  'use strict';

  function previousSameOriginPage() {
    if (!document.referrer) return null;
    try {
      var previous = new URL(document.referrer, window.location.href);
      var current = new URL(window.location.href);
      if (previous.origin !== current.origin || previous.href === current.href) return null;
      return previous;
    } catch (error) {
      return null;
    }
  }

  function fallbackUrl(button) {
    var fallback = button && button.getAttribute('data-bbt-back-fallback');
    if (!fallback) return '/#bbt-vehicle-finder';
    try {
      return new URL(fallback, window.location.origin).href;
    } catch (error) {
      return fallback;
    }
  }

  function goBack(event) {
    var button = event.currentTarget;
    var previous = previousSameOriginPage();
    if (window.history.length > 1 && previous) {
      window.history.back();
      return;
    }
    window.location.assign(fallbackUrl(button));
  }

  function init() {
    var previous = previousSameOriginPage();

    document.querySelectorAll('[data-bbt-global-back-row][data-bbt-back-hide-without-history="1"]').forEach(function (row) {
      if (!previous) row.hidden = true;
    });

    document.querySelectorAll('[data-bbt-vehicle-back]').forEach(function (button) {
      if (button.dataset.bbtBackReady === '1') return;
      button.dataset.bbtBackReady = '1';
      button.addEventListener('click', goBack);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
